import React, { Component } from 'react';

class Details extends Component {



    render() {
        return (
            <div className="details-container">
                {this.props.children}
            </div>
        )

    }
}

export default Details;
